/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ticket_return_error_paid = () => `Sie haben für dieses Ticket bezahlt, es gehört also Ihnen: Sie können es behalten, teilen oder weiterverkaufen. Wenden Sie sich an den Veranstalter, wenn Sie eine Rückerstattung wünschen.`
